import * as React from 'react';
import { SVGProps } from 'react';
const SvgFilters = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 19.15H23v1.1h-5.5v-1.1ZM1 19.15h12.1v1.1H1v-1.1Z"
      fill="current"
    />
    <path
      d="M18.6 19.7a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0Zm-5.28 0a1.98 1.98 0 1 0 3.96 0 1.98 1.98 0 0 0-3.96 0ZM6.5 12.55H1v-1.1h5.5v1.1ZM23 12.55H10.9v-1.1H23v1.1Z"
      fill="current"
    />
    <path
      d="M5.4 12a3.3 3.3 0 1 1 6.6 0 3.3 3.3 0 0 1-6.6 0Zm5.28 0a1.98 1.98 0 1 0-3.96 0 1.98 1.98 0 0 0 3.96 0ZM17.5 3.75H23v1.1h-5.5v-1.1ZM1 3.75h12.1v1.1H1v-1.1Z"
      fill="current"
    />
    <path
      d="M18.6 4.3a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0Zm-5.28 0a1.98 1.98 0 1 0 3.96 0 1.98 1.98 0 0 0-3.96 0Z"
      fill="current"
    />
  </svg>
);
export default SvgFilters;
